import { useLocale } from "next-intl";
import { useQuery } from "@tanstack/react-query";

import { getBettingSelections, GetBettingSelectionsParams } from "@/api/bettingSelections";
import { BettingSelectionsQueryKeys } from "./bettingSelectionsQueryKeys";

export const useBettingSelections = (params: GetBettingSelectionsParams = {}) => {
  const lang = useLocale();
  const fullParams = { lang, ...params };

  return useQuery({
    queryKey: [BettingSelectionsQueryKeys.BettingSelections, fullParams],
    queryFn: ({ signal }) => getBettingSelections({ params: fullParams, signal }),
    enabled: params.bettingMarketId !== undefined,
  });
};
